import { Component, OnChanges, Input } from '@angular/core';

import { MonitoringResultGraph } from '@classes/monitoring/monitoring-result-graph';

@Component({
  selector: 'app-monitoring-graph-modal',
  templateUrl: './monitoring-graph-modal.component.html',
  styleUrls: ['./monitoring-graph-modal.component.scss']
})
export class MonitoringGraphModalComponent implements OnChanges {

    @Input() graph: MonitoringResultGraph;

    constructor () {}

    ngOnChanges (): void {
        if (!this.graph.mode) {
            this.graph.mode =
                this.graph.display === 'multi'
                    ? 'doughnut'
                    : this.graph.display;
        }
    }

}
